<template>
  <!-- 查看物流弹框 -->
  <el-dialog
    class="detailDialog"
    title=""
    :visible.sync="logistDialog"
    :close-on-click-modal="false"
    width="480px"
  >
    <div class="logistics">
      <div class="title">查看物流</div>
      <div class="contentInfo">
        <div class="topWrap">
          <div class="contentWrap">
            <div class="goodsImg">
              <img :src="goodImg">
            </div>
            <div class="textWrap">
              <div class="bottom1">快递公司:{{ logiticObj.expName }}</div>
              <div class="payNo">
                运单号:{{ logiticObj.number }}
                <span
                  v-clipboard:copy="logiticObj.number"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  class="copyInfo"
                >复制</span>
              </div>
            </div>
          </div>
        </div>
        <div ref="logistBody" class="wlWrap">
          <div v-for="(item, index) in logistlist" :key="index" class="itemWrap">
            <div class="time">
              <div class="">{{ item.AcceptTime | getDay }}</div>
              <div class="">{{ item.AcceptTime | getTime }}</div>
            </div>
            <div class="newtext">
              <div class="circle">
                <div class="circleIcon"></div>
              </div>
              {{ item.AcceptStation }}
            </div>
          </div>
        </div>
      </div>
      <div class="actionWrap">
        <span class="savebtn" @click="logistDialog=false">确定</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>

export default {
  filters: {
    getDay(value) {
      if (value) {
        const time = value.split(' ')[0].toString().split('-')
        return time[1] + '-' + time[2]
      }
      return '--'
    },
    getTime(value) {
      if (value) {
        const time = value.split(' ')[1].toString().split(':')
        return time[0] + ':' + time[1]
      }
      return '--'
    }
  },
  data() {
    return {
      logistDialog: false,
      logiticObj: {},
      adressObj: {},
      activeStep: 0,
      logistlist: [],
      goodImg: null
    }
  },
  methods: {
    getLogistic() {
      this.logiticObj = JSON.parse(sessionStorage.getItem('logiticObj'))
      this.goodImg = sessionStorage.getItem('goodImg')
      if (JSON.stringify(this.logiticObj) !== '{}') {
        var list = this.logiticObj.list
        list.forEach((item) => {
          item.AcceptStation = item.status
          item.AcceptTime = item.time
        })
        this.logistlist = list
        this.$nextTick(() => {
          this.$refs.logistBody.scrollTop = 0
        })
      }
      this.logistDialog = true
    },
    onCopy(e) {
      this.$message('你复制了：' + e.text)
    },
    onError() {
      this.$message('请重新复制')
    }
  }
}
</script>

<style lang="scss" scoped>

.detailDialog{
    /deep/.el-dialog__header{
        display: none;
    }
    /deep/.el-dialog__body{
        padding:40px;
    }
    .title{
      font-size: 24px;
      font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
    }
  .topWrap {
    margin-top:10px;
    width: 400px;
    height: 80px;
    // background: #292C3A;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 4px 4px;
    position: relative;
    padding:10px;
    box-sizing: border-box;
    .contentWrap {
      display: flex;
      align-items: center;
      .goodsImg {
        img {
          margin-right: 10px;
          width: 60px;
          height: 60px;
          border-radius: 4px;
        }
      }

      .textWrap {
        // display: flex;
        // align-items: center;
        .bottom1{
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 16px;
        }

        .payNo{
            margin-top:10px;
            font-size: 12px;
            font-family: PingFang HK-Regular, PingFang HK;
            font-weight: 400;
            color: #333333;
        }
        .copyInfo{
            display: inline-block;
            margin-left:10px;
            width: 36px;
            height: 18px;
            background: #000000;
            border-radius: 4px 4px 4px 4px;
            font-size: 10px;
            font-family: PingFang HK-Regular, PingFang HK;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 20px;
            text-align: center;
            cursor: pointer;
        }
      }
    }
  }
  .wlWrap {
    margin-top:10px;
    height: 255px;
    overflow: auto;
    padding: 10px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0px 1px 2px 0px rgba(178,178,178,0.25);
    border-radius: 4px 4px 4px 4px;
    .itemWrap {
      display: flex;
      .time {
        view {
          width: 40px;
          font-size: 10px;
          font-family: symdium;
          font-weight: 500;
          color: #999999;
        }
      }
      .newtext {
        white-space: pre-wrap;
        word-wrap: break-word;
        width: 300px;
        margin-left: 10px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        min-height: 53px;
        padding-bottom:10px;
        height:inherit;
        // border-left: 1px solid #d9d9d9;
        padding-left: 15px;
        position: relative;
        border:none;
        .circle {
          position: absolute;
          left: 2px;
          top: 5px;
          height: calc(100% + 10px);
          border-left: 1px solid #d9d9d9;
          .circleIcon {
            width: 7px;
            height: 7px;
            background-color: #d9d9d9;
            border-radius: 50%;
            position: absolute;
            left: -4px;
          }
        }
      }
      &:last-child{
      .newtext .circle{
          height: 100%;
          border: 0;
          top: 10px;
        }
      }
    }
  }
    .actionWrap{
          margin-top:40px;
          display: flex;
          justify-content: center;
      }

      .savebtn{
          cursor: pointer;
          border-radius: 23px;
          padding: 9px 45px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          border: 1px solid;
          border-color: #000000;
          background: #000000;
      }
  }
  </style>

